import { GetFeed as query } from "@graphql/queries";

const resultsExtractor = (data) => data?.getFeed?.posts;
const nextVariablesExtractor = (data) => data?.getFeed?.nextVariables;

export const GetFeed = {
  query,
  buildOptions: ({
    variables: {
      feedType,
      hashtagId = null,
      user,
      username,
      contentType = null,
      ...restVars
    },
    fetchPolicy = "cache-and-network",
    nextFetchPolicy = "cache-first",
  } = {}) => {
    if (!feedType) {
      throw new Error(`Invalid feedType: ${feedType}`);
    }
    return {
      fetchPolicy,
      nextFetchPolicy,
      partialRefetch: true,
      variables: {
        enableDrawingPosts: true,
        enableTextPosts: true,
        feedType,
        hashtagId,
        targetUserId: user?.id ?? null,
        targetUsername: username ?? null,
        contentType,
        ...restVars,
      },
    };
  },
  buildResult: (result) => {
    Object.assign(result, {
      query,
      resultsExtractor,
      nextVariablesExtractor,
      results: resultsExtractor(result.data),
    });
    return result;
  },
};
